/**
 * Define the list of countries supported within the platform.
 * Each country defines it's ISO ALPHA-2 code and it's name.
 */

const countries = [
  {
    code: 'CA',
    name: 'Canada'
  },
  {
    code: 'US',
    name: 'United States of America'
  }
]

export default countries
